import { render, staticRenderFns } from "./CarLeaveRecord.vue?vue&type=template&id=01093b50&scoped=true&"
import script from "./CarLeaveRecord.vue?vue&type=script&lang=js&"
export * from "./CarLeaveRecord.vue?vue&type=script&lang=js&"
import style0 from "./CarLeaveRecord.vue?vue&type=style&index=0&id=01093b50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01093b50",
  null
  
)

export default component.exports